import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerAdminMembersPage } from './customer-admin-members.page';

const routes: Routes = [
  {
    path: '',
    component: CustomerAdminMembersPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerAdminMembersPageRoutingModule {}
